import React from 'react';
import { Home, Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1F2937] text-white">
      <div className="max-w-[1280px] mx-auto px-6 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Home className="w-8 h-8 text-[#FF5A1F]" />
              <span className="text-xl font-bold">Rolleston Homes</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Creating exceptional homes and building communities across New Zealand.
              Your dream home awaits with our premium construction and design expertise.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-[#FF5A1F] transition-colors duration-200">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#FF5A1F] transition-colors duration-200">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#FF5A1F] transition-colors duration-200">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/homes" className="text-gray-300 hover:text-[#FF5A1F] transition-colors duration-200 text-sm">
                  View All Homes
                </Link>
              </li>
              <li>
                <Link to="/homes/core" className="text-gray-300 hover:text-[#FF5A1F] transition-colors duration-200 text-sm">
                  Core Homes
                </Link>
              </li>
              <li>
                <Link to="/homes/family" className="text-gray-300 hover:text-[#FF5A1F] transition-colors duration-200 text-sm">
                  Family Homes
                </Link>
              </li>
              <li>
                <Link to="/homes/kiwiana" className="text-gray-300 hover:text-[#FF5A1F] transition-colors duration-200 text-sm">
                  Kiwiana Homes
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#FF5A1F] transition-colors duration-200 text-sm">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#FF5A1F] transition-colors duration-200 text-sm">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Home Categories */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Home Categories</h3>
            <ul className="space-y-2">
              <li className="text-gray-300 text-sm">
                <span className="font-medium text-white">Core Homes:</span> Essential living spaces designed for modern lifestyles
              </li>
              <li className="text-gray-300 text-sm">
                <span className="font-medium text-white">Family Homes:</span> Spacious designs perfect for growing families
              </li>
              <li className="text-gray-300 text-sm">
                <span className="font-medium text-white">Kiwiana Homes:</span> Celebrating New Zealand's unique architectural heritage
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#FF5A1F] mt-0.5 flex-shrink-0" />
                <div className="text-gray-300 text-sm">
                  <div>7 Byron St</div>
                  <div>Rolleston</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#FF5A1F] flex-shrink-0" />
                <a href="tel:021550257" className="text-gray-300 hover:text-[#FF5A1F] transition-colors duration-200 text-sm">
                  021 550 257
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#FF5A1F] flex-shrink-0" />
                <a href="mailto:Phil@rollestonhomes.co.nz" className="text-gray-300 hover:text-[#FF5A1F] transition-colors duration-200 text-sm">
                  Phil@rollestonhomes.co.nz
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} Rolleston Homes. All rights reserved.
            </div>
            <div>
              Developed By <a className='hover:text-gray-400' href="https://mocdigitalmedia.com" referrerPolicy='no-referrer' target='_blank'>MOC</a>
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#FF5A1F] transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-[#FF5A1F] transition-colors duration-200">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-[#FF5A1F] transition-colors duration-200">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
